export default __webpack_public_path__ + "static/media/pyspark.c17e04a2.svg";